const Common = {
  '请稍等': '請稍等',
  '操作成功': '操作成功',
  '正常': '正常',
  '系统加载中': '系統加載中',
  '新增': '新增',
  '编辑': '編輯',
  '已选中#条记录': '已選中#筆記錄',
  '未选中任何数据': '未選中任何數據',
  '清空': '清空',
  '删除': '刪除',
  '批量删除': '批量刪除',
  '详情': '詳情',
  '订单详情': '訂單詳情',
  '待接单': '待接單',
  '活跃': '活躍',
  '冻结': '凍結',
  '启用': '啟用',
  '搜索': '搜尋',
  '重置': '重設',
  '操作': '操作',
  '取消': '取消',
  '确定': '確定',
  '状态': '狀態',
  '创建时间': '創建時間',
  '全选': '全選',
  '确定冻结': '確定凍結',
  '确定启用': '確定啟用',
  '确定删除': '確定刪除',
  '确定取消': '確定取消',
  '确定完成': '確定完成',
  '确定下单': '確定下單',
  '确定作废': '確定作廢',
  '确定重置': '確定重置',
  '冻结成功': '凍結成功',
  '启用成功': '啟用成功',
  '删除成功': '刪除成功',
  '重置成功': '重設成功',
  '重置密码': '重設密碼',
  '全部': '全部',
  '备注': '備註',
  '请输入备注': '請輸入備註',
  '暂无数据': '暫無數據',
  '装箱码': '裝箱碼',
  '请输入装箱码': '請輸入裝箱碼',
  '激活码': '激活碼',
  '请输入激活码': '請輸入激活碼',
  '产品码': '產品碼',
  '请输入产品码': '請輸入產品碼',
  '第三方激活码': '第三方激活碼',
  '待完成': '待完成',
  '已收单': '已收單',
  '已完成': '已完成',
  '已作废': '已作廢',
  '待下单': '待下單',
  '产品名称': '產品名稱',
  '产品图片': '產品圖片',
  '基本信息': '基本資訊',
  '序号': '序號',
  '编码': '編碼',
  '请输入编码': '請輸入編碼',
  '暂无': '暫無',
  '待生产': '待生產',
  '已装盒': '已裝盒',
  '已装箱': '已裝箱',
  '生产入库': '生產入庫',
  '采购入库': '採購入庫',
  '销售出库': '銷售出庫',
  '出库激活': '出庫激活',
  '电商激活': '電商激活',
  '完成售后': '完成售後',
  '售后激活': '售後激活',
  '补货出库': '補貨出庫',
  '补货入库': '補貨入庫',
  '订单号': '訂單號',
  '箱规': '箱規',
  '请输入箱规': '請輸入箱規',
  '箱规必须大于0': '箱規必須大於0',
  '请选择产品': '請選擇產品',
  '上一步': '上一步',
  '下一步': '下一步',
  '名称': '名稱',
  '图片': '圖片',
  '单价': '單價',
  '通知': '通知',
  '开始日期': '開始日期',
  '结束日期': '結束日期',
  '请输入': '請輸入',
  '打印': '打印',
  '初始化打印程序失败，请联系技术人员处理': '初始化打印程序失敗，請聯繫技術人員處理',
  '请选择打印机': '請選擇打印機',
  '当前打印数据': '當前打印數據',
  '打印进度': '打印進度',
  '停止打印': '停止打印',
}

const Layout = {
  '语言': '語言',
  '简体中文': '簡體中文',
  '繁体中文': '繁體中文',
  '英文': '英文',
  '修改密码': '修改密碼',
  '退出登录': '退出登錄',
  '溯源管理系统': '溯源管理系統',
}

const Menu = {
  '租户管理': '租戶管理',
  '租户列表': '租戶列表',
  '新增租户': '新增租戶',
  '编辑租户': '編輯租戶',
  '删除租户': '刪除租戶',
  '系统管理': '系統管理',
  '角色管理': '角色管理',
  '角色列表': '角色列表',
  '新增角色': '新增角色',
  '编辑角色': '編輯角色',
  '删除角色': '刪除角色',
  '员工管理': '員工管理',
  '员工列表': '員工列表',
  '新增员工': '新增員工',
  '编辑员工': '編輯員工',
  '删除员工': '刪除員工',
  '销售管理': '銷售管理',
  '销售单': '銷售單',
  '销售单列表': '銷售單列表',
  '新增销售单': '新增銷售單',
  '编辑销售单': '編輯銷售單',
  '销售出库': '銷售出庫',
  '销售出库列表': '銷售出庫列表',
  '新增销售出库': '新增銷售出庫',
  '采购管理': '採購管理',
  '采购单': '採購單',
  '采购单列表': '採購單列表',
  '新增采购单': '新增採購單',
  '编辑采购单': '編輯採購單',
  '采购入库': '採購入庫',
  '采购入库列表': '採購入庫列表',
  '新增采购入库': '新增採購入庫',
  '产品管理': '產品管理',
  '产品库': '產品庫',
  '产品列表': '產品列表',
  '新增产品': '新增產品',
  '编辑产品': '編輯產品',
  '删除产品': '刪除產品',
  '在售产品': '在售產品',
  '在售产品列表': '在售產品列表',
  '新增在售产品': '新增在售產品',
  '删除在售产品': '刪除在售產品',
  '供应商管理': '供應商管理',
  '供应商列表': '供應商列表',
  '新增供应商': '新增供應商',
  '编辑供应商': '編輯供應商',
  '删除供应商': '刪除供應商',
  '代理管理': '代理管理',
  '代理列表': '代理列表',
  '只展示拥有的代理': '只顯示擁有的代理',
  '新增代理': '新增代理',
  '编辑代理': '編輯代理',
  '删除代理': '刪除代理',
  '生产管理': '生產管理',
  '生产单': '生產單',
  '生产单列表': '生產單列表',
  '新增生产单': '新增生產單',
  '编辑生产单': '編輯生產單',
  '生产入库': '生產入庫',
  '生产入库列表': '生產入庫列表',
  '新增生产入库': '新增生產入庫',
  '库存管理': '庫存管理',
  '库存明细': '庫存明細',
  '库存明细列表': '庫存明細列表',
  '库存变动': '庫存變動',
  '库存变动列表': '庫存變動列表',
  '工厂测试': '工廠測試',
  '扫码装盒': '掃碼裝盒',
  '扫码装箱': '掃碼裝箱',
  '扫码校验': '掃碼校驗',
  '扫码激活': '掃碼激活',
  '电商激活': '電商啟用',
  '打印记录': '列印記錄',
  '打印记录列表': '列印記錄列表',
  '新增打印记录': '新增列印記錄',
  '编辑打印记录': '編輯列印記錄',
  '溯源管理': '溯源管理',
  '售后管理': '售後管理',
  '售后列表': '售後列表',
  '新增售后': '新增售後',
  '退货管理': '退貨管理',
  '退货列表': '退貨列表',
  '新增退货': '新增退貨',
  '编辑退货': '編輯退貨',
  'App用户管理': 'App用戶管理',
  'App用户列表': 'App用戶列表',
  '编辑App用户': '編輯App用戶',
  '删除App用户': '刪除App用戶',
  '数据统计': '數據統計',
  '激活记录': '激活記錄',
  '编辑在售产品': '編輯在售產品',
  '第三方激活码管理': '第三方激活碼管理',
  '第三方激活码订单': '第三方激活碼訂單',
  '第三方激活记录': '第三方激活記錄',
  '第三方激活码订单列表': '第三方激活碼訂單列表',
  '新增第三方激活码订单': '新增第三方激活碼訂單',
  '编辑第三方激活码订单': '編輯第三方激活碼訂單',
  '通知管理': '通知管理',
  '代购管理': '代購管理',
  '代购列表': '代購列表',
  '新增代购': '新增代購',
  '只展示自己的代购': '只顯示自己的代購',
  '活动管理': '活動管理',
  '活动列表': '活動列表',
  '新增活动': '新增活動',
  '编辑活动': '編輯活動',
  '删除活动': '刪除活動',
  '扫码验奖': '掃碼驗獎',
}

const Region = {
  '马来西亚': '馬來西亞',
  '玻璃市': '玻璃市',
  '吉打': '吉打',
  '槟城': '檳城',
  '霹雳': '霹靂',
  '雪兰莪': '雪蘭莪',
  '森美兰': '森美蘭',
  '马六甲': '馬六甲',
  '柔佛': '柔佛',
  '彭亨': '彭亨',
  '登嘉楼': '登嘉樓',
  '吉兰丹': '吉蘭丹',
  '砂拉越': '砂拉越',
  '沙巴': '沙巴',
  '吉隆坡': '吉隆坡',
  '纳闽': '納閩',
  '布城': '布城',
  '印度尼西亚': '印度尼西亞',
  '菲律宾': '菲律賓',
  '新加坡': '新加坡',
  '泰国': '泰國',
  '越南': '越南',
  '缅甸': '緬甸',
  '东帝汶': '東帝汶',
  '文莱': '汶萊',
  '柬埔寨': '柬埔寨',
  '老挝': '寮國',
  '阿根廷': '阿根廷',
  '巴拉圭': '巴拉圭',
  '巴西': '巴西',
  '秘鲁': '秘魯',
  '玻利维亚': '玻利維亞',
  '厄瓜多尔': '厄瓜多爾',
  '法属圭亚那': '法屬圭亞那',
  '哥伦比亚': '哥倫比亞',
  '圭亚那': '圭亞那',
  '苏里南': '蘇里南',
  '委内瑞拉': '委內瑞拉',
  '乌拉圭': '烏拉圭',
  '智利': '智利',
  '福克兰群岛': '福克蘭群島',
}

const ModifyPasswordPage = {
  '修改密码': '修改密碼',
  '旧密码': '舊密碼',
  '请输入旧密码': '請輸入舊密碼',
  '新密码': '新密碼',
  '请输入新密码': '請輸入新密碼',
  '密码长度必须介于 6 和 20 之间': '密碼長度必須介於 6 與 20 之間',
  '确认密码': '確認密碼',
  '请再次输入密码': '請再次輸入密碼',
  '两次输入的密码不一致': '兩次輸入的密碼不一致',
  '修改成功': '修改成功',
}

const LoginPage = {
  '账号': '賬號',
  '请输入账号': '請輸入賬號',
  '密码': '密碼',
  '请输入密码': '請輸入密碼',
  '验证码': '驗證碼',
  '请输入验证码': '請輸入驗證碼',
  '登录': '登錄',
}

const TenantPage = {
  '公司名称': '公司名稱',
  '公司联系方式': '公司聯繫方式',
  '公司邮箱': '公司郵箱',
  '管理员名称': '管理員名稱',
  '管理员联系方式': '管理員聯繫方式',
  '管理员邮箱': '管理員郵箱',
  '菜单权限': '菜單權限',
  '管理员账号': '管理員賬號',
  '请输入公司名称': '請輸入公司名稱',
  '请输入公司联系方式': '請輸入公司聯繫方式',
  '请输入公司邮箱': '請輸入公司郵箱',
  '请输入管理员名称': '請輸入管理員名稱',
  '请输入管理员联系方式': '請輸入管理員聯繫方式',
  '请输入管理员邮箱': '請輸入管理員郵箱',
  '邮箱格式错误': '郵箱格式錯誤',
  '请选择菜单权限': '請選擇菜單權限',
  '新增租户': '新增租戶',
  '编辑租户': '編輯租戶',
  '查看租户': '查看租戶',
}

const RolePage = {
  '角色名称': '角色名稱',
  '请输入角色名称': '請輸入角色名稱',
  '新增角色': '新增角色',
  '编辑角色': '編輯角色',
  '查看角色': '查看角色',
  '确定编辑？与该角色关联的账号的权限将会被覆盖': '確定編輯？與該角色關聯的賬號權限將會被覆蓋',
}

const StaffPage = {
  '员工账号': '員工賬號',
  '员工名称': '員工名稱',
  '角色': '角色',
  '请输入员工账号': '請輸入員工賬號',
  '员工账号只能包含数字、英文大小写': '員工賬號只能包含數字、英文大小寫',
  '员工账号长度必须介于 6 和 20 之间': '員工帳號長度必須介於 6 與 20 之間',
  '账号只能包含数字、英文大小写': '賬號只能包含數字、英文大小寫',
  '请输入员工名称': '請輸入員工名稱',
  '请选择角色': '請選擇角色',
}

const PrintRecordPage = {
  '开始': '開始',
  '确定开始': '確定開始',
  '暂停': '暫停',
  '确定暂停': '確定暫停',
  '打印类型': '列印類型',
  '总数量': '總數量',
  '打印数量': '列印數量',
  '排队中': '排隊中',
  '打印中': '列印中',
  '已暂停': '已暫停',
  '已完成': '已完成',
  '已取消': '已取消',
  '打印机状态': '列印機狀態',
}

const ThirdPartyActivationCodeOrderPage = {
  '订单编号': '訂單編號',
  '作废后该订单的所有编码不可使用': '作廢後該訂單的所有編碼不可使用',
  '数量': '數量',
  '请输入数量': '請輸入數量',
  '数量必须大于0': '數量必須大於0',
  '新增订单': '新增訂單',
  '未打印': '未列印',
  '已打印': '已列印',
  '异常打印': '異常列印',
  '打印': '列印',
  '全部打印': '全部列印',
  '请先选择要打印的激活码': '請先選擇要列印的激活碼',
  '打印任务已创建，请到打印记录中查看': '列印任務已建立，請到列印記錄中查看',
}

const ThirdPartyActivationCodeRecordPage = {
  '商品名称': '商品名稱',
  '保修天数': '保修天數',
  '代理': '代理',
  '激活时间': '激活時間',
  '剩余保修天数': '剩餘保修天數',
  '激活人': '激活人',
}

const TraceCodePage = {
  '溯源': '溯源',
  '暂无溯源信息': '暫無溯源資訊',
  '产品信息': '產品資訊',
  '产品单价': '產品單價',
  '包装信息': '包裝資訊',
  '装箱信息': '裝箱資訊',
  '装箱情况': '裝箱情況',
  '当前节点': '當前節點',
  '产品节点': '產品節點',
  '激活状态': '激活狀態',
  '剩余时间（天）': '剩餘時間（天）',
  '销售门店': '銷售門店',
  '激活账号': '激活帳號',
  '绑定用户': '綁定用戶',
  '已激活': '已激活',
  '未激活': '未激活',
}

const ReturnPage = {
  '我的退货': '我的退貨',
  '处理退货': '處理退貨',
  '确定收货': '確定收貨',
  '完成退货': '完成退貨',
  '退货详情': '退貨詳情',
  '补发详情': '補發詳情',
  '退货数量': '退貨數量',
  '退货收货数量': '退貨收貨數量',
  '补发数量': '補發數量',
  '补发收货数量': '補發收貨數量',
  '退货人': '退貨人',
  '补发人': '補發人',
  '退货中': '退貨中',
  '收货中': '收貨中',
  '已收货': '已收貨',
  '补发中': '補發中',
  '已补发': '已補發',
  '已完成': '已完成',
  '售后类型': '售後類型',
  '其他': '其他',
  '其他原因': '其他原因',
}

const StockChangePage = {
  '类型': '類型',
  '关联订单号': '關聯訂單號',
  '商品数量': '商品數量',
  '关联生产单信息': '關聯生產單資訊',
  '关联销售单信息': '關聯銷售單資訊',
  '销售数量': '銷售數量',
  '关联采购单': '關聯採購單',
  '客户': '客戶',
  '客户拥有人': '客戶擁有人',
  '关联采购单信息': '關聯採購單資訊',
  '采购数量': '採購數量',
  '供应商': '供應商',
}

const StockPage = {
  '库存详情': '庫存詳情',
}

const SaleOutWarehousePage = {
  '请选择关联销售单': '請選擇關聯銷售單',
}

const SaleOrderPage = {
  '确定接收': '確定接收',
  '创建生产单': '創建生產單',
  '销售出库详情': '銷售出庫詳情',
  '出库进度': '出庫進度',
  '出库状态': '出庫狀態',
  '客户入库数量': '客戶入庫數量',
  '未出库': '未出庫',
  '部分出库': '部分出庫',
  '已出库': '已出庫',
  '采购地区': '採購地區',
  '销售出库数量': '銷售出庫數量',
  '发货时间': '發貨時間',
  '请输入采购数量': '請輸入採購數量',
  '采购数量必须大于0': '採購數量必須大於0',
  '请选择客户': '請選擇客戶',
  '请选择采购地区': '請選擇採購地區',
  '请选择出货日期': '請選擇出貨日期',
  '采购方': '採購方',
  '采购方备注': '採購方備註',
}

const PurchaseInWarehousePage = {
  '采购商品数量': '採購商品數量',
  '入库商品数量': '入庫商品數量',
}

const PurchaseOrderPage = {
  '采购': '採購',
  '发货日期': '發貨日期',
  '采购入库详情': '採購入庫詳情',
  '采购入库数量': '採購入庫數量',
  '商品明细': '商品明細',
  '件商品': '件商品',
  '入库进度': '入庫進度',
  '入库状态': '入庫狀態',
  '商品': '商品',
  '单价': '單價',
  '种': '種',
  '未入库': '未入庫',
  '部分入库': '部分入庫',
  '已入库': '已入庫',
  '请选择供应商': '請選擇供應商',
  '请输入采购数量': '請輸入採購數量',
  '采购数量必须大于0': '採購數量必須大於0',
  '请选择发货日期': '請選擇發貨日期',
  '发货数量': '發貨數量',
  '出货备注': '出貨備註',
  '入库备注': '入庫備註',
  '销售方': '銷售方',
  '销售方备注': '銷售方備註',
}

const AppUserPage = {
  '用户名称': '用戶名稱',
  '手机号': '手機號',
  '邮箱': '郵箱',
  '用户账号': '用戶賬號',
  '车型': '車型',
  '绑定数': '綁定數',
}

const ProduceInWarehousePage = {
  '请选择关联生产单': '請選擇關聯生產單',
}

const ProduceOrderPage = {
  '生产入库详情': '生產入庫詳情',
  '生产数量': '生產數量',
  '生产入库数量': '生產入庫數量',
  '请输入生产数量': '請輸入生產數量',
  '生产数量必须大于0': '生產數量必須大於0',
  '请输入装箱码、激活码或者产品码': '請輸入裝箱碼、激活碼或者產品碼',
  '产品箱装数量': '產品箱裝數量',
  '请先选择要打印的装箱码': '請先選擇要列印的裝箱碼',
  '确定要打印#个装箱码': '確定要列印#個裝箱碼',
  '请先选择要打印的产品码': '請先選擇要列印的產品碼',
  '确定要打印#个产品码': '確定要列印#個產品碼',
  '绑定状态': '綁定狀態',
  '已绑定': '已綁定',
  '待绑定': '待綁定',
  '新增箱子': '新增箱子',
  '编辑箱子': '編輯箱子',
  '箱子数量': '箱子數量',
  '请输入箱子数量': '請輸入箱子數量',
  '箱子数量必须大于0': '箱子數量必須大於0',
  '编码生成方式': '編碼生成方式',
  '设备生成': '設備生成',
  '系统生成': '系統生成',
}

const OnSaleProductPage = {
  '库存': '庫存',
  '请输入库存': '請輸入庫存',
  '新增在售产品': '新增在售產品',
  '配置在售产品': '配置在售產品',
  '旧单价': '舊單價',
  '单价更新时间': '單價更新時間',
}

const ProductPage = {
  '导入': '導入',
  '模版下载': '模版下載',
  '文件格式为.xlsx、.xls': '檔案格式為.xlsx、.xls',
  '导入完毕，成功：#1，失败：#2': '導入完畢，成功：#1，失敗：#2',
  '产品导入模板': '產品匯入範本',
  '请输入产品名称': '請輸入產品名稱',
  '请上传图片': '請上傳圖片',
  '请输入产品单价': '請輸入產品單價',
  '请输入规格编码': '請輸入規格編碼',
  '规格编码不能少于2位': '規格編碼不能少於2位',
  '规格编码只能包含数字、英文大小写': '規格編碼只能包含數字、英文大小寫',
  '图片尺寸为800x800': '圖片尺寸為800x800',
  '规格编码': '規格編碼',
  '规格编码为数字+英文大小写的6位编码': '規格編碼為數字+英文大小寫的6位編碼',
  '图片格式为.jpeg、.jpg、.png': '圖片格式為.jpeg、.jpg、.png',
  '图片必须小于1M': '圖片必須小於1M',
  '图片尺寸必须为800x800': '圖片尺寸必須為800x800',
  '产品指导价': '產品指導價',
  '国家': '國家',
  '价格': '價格',
  '请添加指导价': '請添加指導價',
  '请选择国家': '請選擇國家',
  '国家重复': '國家重複',
  '功能列表': '功能列表',
  '设备锁': '設備鎖',
}

const AgentPage = {
  '代理账号': '代理帳號',
  '代理名称': '代理名稱',
  '代理总数': '代理總數',
  '代理手机号': '代理手機號',
  '代理邮箱': '代理郵箱',
  '地区': '地區',
  '地址': '地址',
  '请输入代理账号': '請輸入代理賬號',
  '代理账号只能包含数字和英文字母': '代理賬號只能包含數字和英文字母',
  '请输入代理名称': '請輸入代理名稱',
  '代理名称长度必须介于 2 和 20 之间': '代理名稱長度必須介於 2 和 20 之間',
  '请输入代理手机号': '請輸入代理手機號',
  '手机号只包含数字': '手機號只包含數字',
  '手机号无需加区号': '手機號無需加區號',
  '请输入代理邮箱': '請輸入代理郵箱',
  '请选择地区': '請選擇地區',
  '请输入地址': '請輸入地址',
  '下级代理': '下級代理',
  '代理采购记录': '代理採購記錄',
  '代理库存': '代理庫存',
  '拥有者': '擁有者',
  '迁移': '遷移',
  '迁移代理': '遷移代理',
  '请选择拥有者': '請選擇擁有者',
  '采购时间': '採購時間',
  '下载模版': '下載模版',
  '下载成功': '下載成功',
  '下载失败': '下載失敗',
  '代理导入模版': '代理導入模版',
  '导入成功': '導入成功',
  '导入失败': '導入失敗',
  '联系人': '聯絡人',
  '请输入联系人': '請輸入聯絡人',
}

const SupplierPage = {
  '供应商账号': '供應商賬號',
  '供应商名称': '供應商名稱',
  '请输入供应商名称': '請輸入供應商名稱',
  '供应商联系方式': '供應商聯繫方式',
  '请输入供应商联系方式': '請輸入供應商聯繫方式',
  '供应商地址': '供應商地址',
  '请输入供应商地址': '請輸入供應商地址',
  '查看供应商': '檢視供應商',
}

const StatisticsPage = {
  '用户': '用戶',
  '绑定信息': '綁定資訊',
  '库存数量': '庫存數量',
  '代理入库总数': '代理入庫總數',
  '产品未激活总数': '產品未激活總數',
  '产品激活详情': '產品激活詳情',
  '产品激活排行': '產品激活排行',
  '售后产品数': '售後產品數',
  '请输入名称搜索内容': '請輸入名稱搜索內容',
  '总代账号': '總代帳號',
  '全店数据概况': '全店數據概況',
  '统计首页': '統計首頁',
  '首页': '首頁',
  '至': '至',
  '表格': '表格',
  '图标': '圖表',
  '注册人数': '註冊人數',
  '总代理商名称': '總代理商名稱',
  '总代理名称': '總代理名稱',
  '总代理商号': '總代理商號',
  '总代理昵称': '總代理暱稱',
  '代理门店数': '代理門店數',
  '员工数': '員工數',
  '采购数': '採購數',
  '采购订单数': '採購訂單數',
  '业务员': '業務員',
  '起始时间': '起始時間',
  '结束时间': '結束時間',
  '平台数据概况': '平台數據概況',
  '统计时间': '統計時間',
  '代理数据概况': '代理數據概況',
  '激活数量': '激活數量',
  '用户绑定': '用戶綁定',
  '产品售后': '產品售後',
  '代理门店': '代理門店',
  '地区总代总数': '地區總代總數',
  '销售单总数': '銷售單總數',
  '采购单总数': '採購單總數',
  '统计': '統計',
  '用户绑定总数': '用戶綁定總數',
  '代理门店总数': '代理門店總數',
  '代理门店数': '代理門店數',
  '操作': '操作',
  '详情': '詳情',
  '请输入代理名称': '請輸入代理名稱',
  '代理名称': '代理名稱',
  '代理总数': '代理總數',
  '账号': '帳號',
  '代理地区': '代理地區',
  '发展员名称': '發展員名稱',
  '发展员账号': '發展員帳號',
  '请输入搜索内容': '請輸入搜索內容',
  '产品售后总数': '產品售後總數',
  '商品排名分析': '商品排名分析',
  '数据详情': '數據詳情',
  '产品激活排名详情': '產品激活排名詳情',
  '排名': '排名',
  '用户绑定数': '用戶綁定數',
  '更新于': '更新於',
  '今日': '今日',
  '日': '日',
  '周': '週',
  '月': '月',
  '开始日期': '開始日期',
  '结束日期': '結束日期',
  '数据首页': '數據首頁',
  '用户总注册人数': '用戶總註冊人數',
  '产品销售总数': '產品銷售總數',
  '产品激活总数': '產品激活總數',
  '代理总数': '代理總數',
  '用户注册人数': '用戶註冊人數',
  '产品销售数': '產品銷售數',
  '产品激活数': '產品激活數',
  '入库数量': '入庫數量',
  '未激活数量': '未激活數量',
  '产品编号': '產品編號',
  '代理地区': '代理地區',
  '请输入搜索内容': '請輸入搜索內容',
  '销售单总数': '銷售單總數',
  '订单编号': '訂單編號',
  '销售数量': '銷售數量',
  '销售时间': '銷售時間',
  '售后数量': '售後數量',
  '销售单数': '銷售單數',
  '产品售后数量': '產品售後數量',
  '请输入搜索名称': '請輸入搜索名稱',
  '销售订单数': '銷售訂單數',
  '销售员': '銷售員',
  '销售员账号': '銷售員帳號',
  '产品编码': '產品編碼',
  '绑定时间': '綁定時間',
  '激活信息': '激活資訊',
  '用户绑定总数': '用戶綁定總數',
  '总代理商名称': '總代理商名稱',
  '总代理账号': '總代理帳號',
  '用户绑定数': '用戶綁定數',
  '注册时间': '註冊時間',
  '请输入国家名称': '請輸入國家名稱',
  '详情功能暂未开放': '詳情功能暫未開放',
  '剩余保修时间': '剩餘保修時間',
  '天': '天',
  '销售单产品总数': '銷售單產品總數',
  '出库数量': '出庫數量',
  '代理入库数量': '代理入庫數量',
  '未激活数量': '未激活數量',
  '产品售后数': '產品售後數',
  '销售单时间': '銷售單時間',
  '订单编号': '訂單編號',
  '起始时间': '起始時間',
  '结束时间': '結束時間',
  '无图片': '無圖片',
  '代理数': '代理數',
  '请选择': '請選擇',
  '产品销售': '產品銷售',
  '产品激活': '產品啟用',
  '销售方': '銷售方',
  '激活方': '激活方',
  '归属方': '歸屬方',
  '激活账号': '激活帳號',
  '激活门店': '激活門店',
  '剩余保修时间': '剩餘保修時間',
  '产品激活时间': '產品激活時間',
  '用户绑定时间': '用戶綁定時間',
  '绑定数量': '綁定數量',
  '国家地区': '國家地區',
  '注册时间': '註冊時間',
  '各国注册人数对比': '各國註冊人數對比',
  '暂无绑定信息': '暫無綁定資訊',
  '账号名称': '帳號名稱',
  '采购产品数': '採購產品數',
  '产品入库数': '產品入庫數',
  '产品出库数': '產品出庫數',
  '库存总数': '庫存總數',
  '采购工厂': '採購工廠',
  '采购工厂账号': '採購工廠帳號',
  '采购单时间': '採購單時間',
  '订单总数': '訂單總數',
  '产品采购总数': '產品採購總數',
  '产品入库总数': '產品入庫總數',
  '产品出库总数': '產品出庫總數',
  '激活总数': '激活總數',
  '未激活总数': '未激活總數',
  '售后总数': '售後總數',
  '请输入产品名称': '請輸入產品名稱',
  '代理门店': '代理門店',
  '代理账号': '代理帳號',
  '手机号': '手機號',
  '邮箱': '郵箱',
  '业务员名称': '業務員名稱',
  '业务员账号': '業務員帳號',
  '售后数': '售後數',
  '售后信息': '售後資訊',
  '售后门店': '售後門店',
  '售后账号': '售後帳號',
  '原产品编码': '原產品編碼',
  '更换产品编码': '更換產品編碼',
  '绑定用户': '綁定用戶',
  '用户账号': '用戶帳號',
  '产品激活时间': '產品激活時間',
  '用户绑定时间': '用戶綁定時間',
  '售后时间': '售後時間',
  '代理名称': '代理名稱',
  '用户名': '用戶名',
  '昵称': '暱稱',
  '保修天数': '保修天數',
  '激活时间': '激活時間',
  '绑定时间': '綁定時間',
  '创建时间': '創建時間',
  '激活数': '激活數',
  '用户绑定数': '用戶綁定數',
  '激活门店': '激活門店',
  '激活账号': '激活帳號',
  '激活昵称': '激活暱稱',
  '绑定昵称': '綁定暱稱',
  '绑定账号': '綁定帳號',
  '销售详情': '銷售詳情',
  '请输入代理门店名称': '請輸入代理門店名稱',
  '销售方名称': '銷售方名稱',
  '销售方账号': '銷售方帳號',
}

const InsiteMessagePage = {
  '标题': '標題',
  '内容': '內容',
  '已读': '已讀',
  '未读': '未讀',
  '全部已读': '全部已讀',
  '确定全部设置为已读': '確定全部設定為已讀',
  '发送时间': '發送時間',
  '查看消息': '查看訊息',
  '您有新的销售单': '您有新的銷售單',
  '订单号：{no}\n产品名称：{productName}\n件数：{caseQuantity}\n个数：{quantity}\n请尽快接单！':
      '訂單號：{no}\n產品名稱：{productName}\n件數：{caseQuantity}\n個數：{quantity}\n請盡快接單！',
  '订单号：{no}\n产品名称：{productName}\n数量：{quantity}\n请尽快接单！':
      '訂單號：{no}\n產品名稱：{productName}\n數量：{quantity}\n請盡快接單！',
  '订单号：{no}\n采购方：{purchaseTenantName}\n产品名称：{productName}\n请尽快接单！': '訂單號：{no}\n採購方：{purchaseTenantName}\n產品名稱：{productName}\n請盡快接單！',
  '订单号：{no}\n采购方：{purchaseTenantName}\n产品名称：{productName}\n请尽快接单！': '訂單號：{no}\n採購方：{purchaseTenantName}\n產品名稱：{productName}\n請盡快接單！',
  '订单备注更新': '訂單備註更新',
  '订单号：{no}\n备注：{remark}': '訂單號：{no}\n備註：{remark}',
  '销售单作废': '銷售單作廢',
  '订单号：{no}\n作废时间：{time}': '訂單號：{no}\n作廢時間：{time}',
  '完成销售单': '完成銷售單',
  '订单号：{no}\n完成时间：{time}': '訂單號：{no}\n完成時間：{time}',
  '采购单接单': '採購單接單',
  '订单号：{no}\n接单时间：{time}': '訂單號：{no}\n接單時間：{time}',
  '采购单作废': '採購單作廢',
  '生产入库': '生產入庫',
  '完成生产入库': '完成生產入庫',
  '采购单发货': '採購單發貨',
  '订单号：{no}\n件数：{caseQuantity}\n个数：{quantity}\n发货时间：{time}':
      '訂單號：{no}\n件數：{caseQuantity}\n個數：{quantity}\n發貨時間：{time}',
  '订单号：{no}\n个数：{quantity}\n发货时间：{time}':
      '訂單號：{no}\n個數：{quantity}\n發貨時間：{time}',
  '销售出库': '銷售出庫',
  '订单号：{no}\n件数：{caseQuantity}\n个数：{quantity}\n出库时间：{time}':
      '訂單號：{no}\n件數：{caseQuantity}\n個數：{quantity}\n出庫時間：{time}',
  '订单号：{no}\n个数：{quantity}\n出库时间：{time}':
      '訂單號：{no}\n個數：{quantity}\n出庫時間：{time}',
  '采购入库': '採購入庫',
  '订单号：{no}\n件数：{caseQuantity}\n个数：{quantity}\n入库时间：{time}':
      '訂單號：{no}\n件數：{caseQuantity}\n個數：{quantity}\n入庫時間：{time}',
  '订单号：{no}\n个数：{quantity}\n入库时间：{time}':
      '訂單號：{no}\n個數：{quantity}\n入庫時間：{time}',
  '完成采购单': '完成採購單',
  '产品激活': '產品啟用',
  '产品名称：{productName}\n激活人员：{staffName}\n激活时间：{time}':
      '產品名稱：{productName}\n啟用人員：{staffName}\n啟用時間：{time}',
  '库存预警': '庫存預警',
  '产品名称：{productName}\n数量：{quantity}\n请尽快补货！':
      '產品名稱：{productName}\n數量：{quantity}\n請盡快補貨！',
  '产品售后': '產品售後',
  '产品名称：{productName}\n旧编码：{oldProductCode}\n新编码：{newProductCode}\n售后时间：{time}\n售后人员：{staffName}':
      '產品名稱：{productName}\n舊編碼：{oldProductCode}\n新編碼：{newProductCode}\n售後時間：{time}\n售後人員：{staffName}',
  '新的退货申请': '新的退貨申請',
  '产品名称：{productName}\n个数：{quantity}\n申请方：{applierName}':
      '產品名稱：{productName}\n個數：{quantity}\n申請方：{applierName}',
  '退货收货': '退貨收貨',
  '产品名称：{productName}\n个数：{quantity}\n收货时间：{time}':
      '產品名稱：{productName}\n個數：{quantity}\n收貨時間：{time}',
  '退货发货': '退貨發貨',
  '产品名称：{productName}\n个数：{quantity}\n发货时间：{time}':
      '產品名稱：{productName}\n個數：{quantity}\n發貨時間：{time}',
  '完成退货': '完成退貨',
  '产品名称：{productName}\n个数：{quantity}\n完成时间：{time}':
      '產品名稱：{productName}\n個數：{quantity}\n完成時間：{time}',
  '新的召回申请': '新的召回申請',
  '采购单编号：{no}\n申请方：{applicantName}':
      '採購單編號：{no}\n申請方：{applicantName}',
  '召回申请通过': '召回申請通過',
  '采购单编号：{no}\n审批方：{approverName}\n审批时间：{time}':
      '採購單編號：{no}\n審批方：{approverName}\n審批時間：{time}',
  '召回申请驳回': '召回申請駁回',
  '采购单编号：{no}\n审批方：{approverName}\n驳回时间：{time}':
      '採購單編號：{no}\n審批方：{approverName}\n駁回時間：{time}',
  '完成添加召回商品': '完成新增召回商品',
  '采购单编号：{no}\n完成时间：{time}':
      '採購單編號：{no}\n完成時間：{time}',
  '完成召回商品核验': '完成召回商品核驗',
  '完成召回': '完成召回',
  '召回补货入库': '召回補貨入庫',
  '召回发货出库': '召回發貨出庫',
}

const AgentPurchasePage = {
  '采购方': '採購方',
  '代购人': '代購人',
  '代理': '代理',
  '请选择代理': '請選擇代理',
}

const CampaignPage = {
  '活动名称': '活動名稱',
  '开奖状态': '開獎狀態',
  '开奖进度': '開獎進度',
  '开奖编码': '開獎編碼',
  '领取状态': '領取狀態',
  '已领取': '已領取',
  '未领取': '未領取',
  '未发布': '未發佈',
  '参与中': '參與中',
  '待开奖': '待開獎',
  '开奖中': '開獎中',
  '已结束': '已結束',
  '查看地区': '查看地區',
  '信息收集': '資訊收集',
  '活动条件': '活動條件',
  '活动产品': '活動產品',
  '选择产品': '選擇產品',
  '开奖人数': '開獎人數',
  '参与范围': '參與範圍',
  '产品来源仅限': '產品來源僅限',
  '起始时间': '起始時間',
  '产品购买时间在': '產品購買時間在',
  '后': '後',
  '奖品': '獎品',
  '奖品名称': '獎品名稱',
  '奖品图片': '獎品圖片',
  '图片尺寸为1:1': '圖片尺寸為1:1',
  '奖品价值': '獎品價值',
  '奖品数量': '獎品數量',
  '中奖规则': '中獎規則',
  '规则描述': '規則描述',
  '活动图': '活動圖',
  '图片尺寸为690x420': '圖片尺寸為690x420',
  '内容': '內容',
  '图片宽度为750像素': '圖片寬度為750像素',
  '图片必须小于5M': '圖片必須小於5M',
  '其他信息': '其他資訊',
  '领奖最后期限': '領獎最後期限',
  '手机号码': '手機號碼',
  '开奖后': '開獎後',
  '天': '天',
  '请输入活动名称': '請輸入活動名稱',
  '请上传图片': '請上傳圖片',
  '请完善活动详情': '請完善活動詳情',
  '请选择活动产品': '請選擇活動產品',
  '请输入开奖人数': '請輸入開獎人數',
  '请选择查看地区': '請選擇查看地區',
  '请选择代理': '請選擇代理',
  '请选择起始时间': '請選擇起始時間',
  '请输入奖品名称': '請輸入獎品名稱',
  '请上传奖品图片': '請上傳獎品圖片',
  '请输入奖品数量': '請輸入獎品數量',
  '请选择信息收集方式': '請選擇資訊收集方式',
  '请输入规则描述': '請輸入規則描述',
  '请输入领奖最后期限': '請輸入領獎最後期限',
  '发布': '發佈',
  '确定发布': '確定發佈',
  '撤销': '撤銷',
  '确定撤销': '確定撤銷',
  '中奖信息': '中獎資訊',
  '中奖编码': '中獎編碼',
  '中奖用户': '中獎用戶',
  '用户信息': '用戶資訊',
  '领奖状态': '領獎狀態',
  '选择': '選擇',
  '最多10个产品': '最多10個產品',
  '时间类型': '時間類型',
  '起止时间': '起訖時間',
  '请选择终止时间': '請選擇終止時間',
  '起始时间不能大于终止时间': '起始時間不能大於終止時間',
};

const BackEnd = {
  'Select_Role': '請選擇角色',
  'No_Third_Party_Active_Code': '第三方激活碼不存在',
  'Error_Third_Party_Active_Code': '錯誤第三方激活碼',
  'Not_Print_Third_Party_Active_Code': '未列印第三方激活碼',
  'No_After_Sale_Code': '售後碼不存在',
  'No_Goods': '產品不存在',
  'Not_Sale_Goods': '非銷售產品',
  'No_Product_Code': '產品碼不存在',
  'After_Sale_Code_Not_Belong_Product_Code': '售後碼不屬於該產品碼',
  'No_New_Product_Code': '新產品碼不存在',
  'Error_Product_Code': '異常產品碼',
  'Not_Print_Product_Code': '未列印產品碼',
  'Not_Same_Product': '非同一產品',
  'Active': '已激活',
  'Out_Of_Stock': '庫存不足',
  'No_App_User': '用戶不存在',
  'Invalid_Active_Code_Or_Invalid_Product_Code': '非法激活碼/產品碼',
  'No_Active_Code': '激活碼不存在',
  'Not_Active': '未激活',
  'Bind': '已綁定',
  'Account_Exist': '帳號重複',
  'Concat_Superior_Reset_Password': '聯繫上級重置密碼',
  'No_User': '用戶不存在',
  'Old_Password_Error': '舊密碼錯誤',
  'No_Active_Code_Order': '第三方激活碼訂單不存在',
  'Invalid_Active_Code_Order_Status': '非法第三方激活碼訂單狀態',
  'Invalid_Quantity': '數量錯誤',
  'No_Agent': '代理不存在',
  'Select_Agent': '請選擇代理',
  'No_Staff': '員工不存在',
  'Enter_Agent_Name': '請輸入代理名稱',
  'Enter_Agent_Phone': '請輸入代理手機號碼',
  'Select_Agent_Region': '請選擇代理地區',
  'Enter_Agent_Address': '請輸入代理地址',
  'Select_Product': '請選擇產品',
  'Enter_Goods_Quantity': '請輸入產品數量',
  'Upload_File': '請上傳檔案',
  'No_Insite_Message': '訊息不存在',
  'No_Product': '產品不存在',
  'Enter_Price': '請輸入單價',
  'Invalid_Price': '非法單價',
  'Select_Produce_Order': '請選擇生產單',
  'Select_Print_Type': '請選擇列印類型',
  'Invalid_Print_Type': '非法列印類型',
  'No_Produce_Order': '生產單不存在',
  'Invalid_Produce_Order_Status': '非法生產單狀態',
  'Out_Of_Produce_Order_Goods_Quantity': '超過生產數量',
  'Invalid_Box_Code': '非法裝箱碼',
  'No_Box_Code': '裝箱碼不存在',
  'Error_Box_Code': '異常裝箱碼',
  'Not_Print_Box_Code': '未列印裝箱碼',
  'Not_Same_Produce_Order': '非同一生產單',
  'Produce_In_Warehouse': '已生產入庫',
  'Select_Goods': '請選擇產品',
  'Some_Goods_In_Warehouse': '部分產品已入庫，不能作廢',
  'Error_Active_Code': '異常激活碼',
  'Not_Print_Active_Code': '未列印激活碼',
  'Product_Associate_Box': '產品已關聯包裝盒',
  'Box_Not_Associate_Product': '包裝盒未關聯產品',
  'Box_Associate_Case': '包裝盒已關聯包裝箱',
  'Enter_Box_Quantity': '請輸入箱規',
  'Scan_Active_Code': '請掃描激活碼',
  'Invalid_Active_Code': '非法激活碼',
  'Scan_Product_Code': '請掃描產品碼',
  'Invalid_Product_Code': '非法產品碼',
  'Scan_Box_Code': '請掃描裝箱碼',
  'Success': '成功',
  'Product_Name_Exist': '產品名稱重複',
  'Sku_Exist': '規格編碼重複',
  'Enter_Product_Name': '請輸入產品名稱',
  'Enter_Product_Sku': '請輸入規格編碼',
  'Not_Allow_Modify_Super_User': '不允許修改超管帳號',
  'No_Permission': '無權限',
  'Import_Empty_User_Data': '導入用戶數據為空',
  'No_Purchase_Order': '採購單不存在',
  'Invalid_Purchase_Order_Status': '非法採購單狀態',
  'Out_Of_Purchase_Order_Goods_Quantity': '超過採購數量',
  'Not_Belong_Purchase_Order': '不屬於該採購單',
  'Select_Purchase_Order': '請選擇採購單',
  'Select_PurchaseTenant': '請選擇採購商',
  'Has_Goods_Not_Purchase_In_Warehouse': '銷售方已發貨，但未入庫',
  'No_Sale_Order': '銷售單不存在',
  'Select_ShipmentTime': '請選擇發貨時間',
  'No_Return_Goods': '退貨不存在',
  'No_After_Sale': '售後不存在',
  'Return_Goods': '已退貨',
  'Invalid_Return_Goods_Record_Status': '非法退貨記錄狀態',
  'Not_Belong_Return_Goods_Record': '不屬於該退貨申請',
  'Received': '已收貨',
  'Out_Of_Return_Goods_Quantity': '超過退貨數量',
  'No_Return_Goods_Record': '退貨記錄不存在',
  'Invalid_Approver': '非法審核員',
  'Not_In_Warehouse': '不在庫存',
  'Reship': '已補發',
  'Select_Return_Goods_Record': '請選擇退貨記錄',
  'No_Allow_Operate_Super_Role': '不允許操作超級管理員角色',
  'No_Permission_Access_Role': '沒有權限訪問角色',
  'No_Permission_Access_Dept': '沒有權限訪問部門',
  'No_Allow_Add_Dept': '部門停用，不允許新增',
  'Invalid_Sale_Order_Status': '非法銷售單狀態',
  'Some_Goods_Out_Warehouse': '部分產品已出庫，不能作廢',
  'Out_Of_Sale_Order_Goods_Quantity': '超過銷售數量',
  'Select_Sale_Order': '請選擇銷售單',
  'Not_Associate': '未關聯',
  'Scan_Code': '請掃碼',
  'Enter_Nick_Name': '請輸入名稱',
  'Select_MenuIds': '請選擇菜單',
  'No_Stock_Change': '庫存變動不存在',
  'Enter_Supplier_Name': '請輸入供應商名稱',
  'Enter_Supplier_Phone': '請輸入供應商手機號碼',
  'Enter_Company_Name': '請輸入公司名稱',
  'Enter_Company_Phone': '請輸入公司手機號碼',
  'Enter_Company_Email': '請輸入公司郵箱',
  'Enter_Contact_Name': '請輸入聯繫人名稱',
  'Enter_Contact_Phone': '請輸入聯繫人手機號碼',
  'Enter_Contact_Email': '請輸入聯繫人郵箱',
  'Enter_Captcha': '請輸入驗證碼',
  'Captcha_Expire': '驗證碼過期',
  'Error_Captcha': '驗證碼錯誤',
  'Enter_Account/Password': '請輸入帳號/密碼',
  'Password_Not_Between_Range': '密碼不在指定範圍',
  'User_Name_Not_Between_Range': '用戶名不在指定範圍',
  'IP_Be_Banned': 'IP禁止訪問',
  'Account_Be_Deleted': '帳號已刪除',
  'Account_Be_Freeze': '帳號已凍結',
  'Enter_User/Password': '請輸入帳號/密碼',
  'Account_Between_2_And_20': '帳號長度在2-20之間',
  'Password_Between_6_And_20': '密碼長度在6-20之間',
  'Error Account/Password': '錯誤帳號/密碼',
  'Enter_Mobile_Phone': '請輸入手機號碼',
  'Enter_Email': '請輸入郵箱',
  'Frequently_Get_Captcha_Try_5_Minutes': '頻繁獲取驗證碼，5分鐘後再試',
  'No_User/Password_Error': '用戶不存在/密碼錯誤',
  'Purchase_In_Warehouse': '已採購入庫',
  'Sale_Out_Warehouse': '已銷售出庫',
  'Free': '空閒',
  'CustomCode': '第三方激活碼',
  'Order_Out_Of_Limit（999）': '超過上限（999）',
  'Other': '其他',
  'No_Campaign': '活動不存在',
  'Not_In_Participate': '不在參與期',
  'Has_Participant': '存在參與的用戶',
  'Has_One_Active': '存在發佈的活動',
  'Has_One_Participate': '存在已有參與用戶的活動',
  'Participated': '已參與',
  'No_Valid_Bind_Product': '未綁定符合條件的產品',
  'Invalid_Accept_No': '非法領獎碼',
  'Accept_Prize': '已領獎',
  'Scan_Accept_No': '請掃描領獎碼',
  'Out_Of_Accept_Deadline': '超過領獎最後期限',
  'Enter_Title': '請輸入活動名稱',
  'Upload_Banner': '請上傳Banner',
  'Enter_Content': '請完善內容',
  'Enter_Max_Participant_Quantity': '請輸入參與人數上限',
  'Select_Limit_Date': '請選擇限制時間',
  'Improve_Prize': '請完善獎品',
  'Select_Contact_Method': '請選擇聯繫方式',
  'Enter_Rule_Desc': '請輸入規則描述',
  'Enter_Accept_Deadline': '請輸入領獎期限',
  'Enter_Phone': '請輸入手機號碼',
  'Out_Of_Max_Participant_Quantity': '超過參與人數上限',
  'Not_Bind': '未綁定',
  'Select_Purchase_Order': '請選擇採購單',
  'Empty_Product_Code': '產品編碼不能為空',
  'Product_Not_Found': '產品不存在',
  'Empty_Box_Code': '箱碼為空',
  'Print_Failed': '列印失敗，請檢查印表機狀態',
  'Empty_Product_Code': '產品碼為空',
  'Product_Code_Not_Exist': '產品碼不存在',
  'Box_Code_Not_Exist': '箱碼不存在',
  'System_Clock_Backwards': '系統時鐘回撥，拒絕生成ID',
  'Empty_User_Id': '用戶ID不能為空',
  'Empty_Tenant_Id': 'tenantId不能為空',
  'Empty_Product_Id': 'productId不能為空',
  'Please_Enter_Product_Id': '請填入productId',
  'Invalid_Product_Code_Empty_Part': '產品代碼空白部分無效',
  'Invalid_Product_Code_Format': '產品代碼格式無效',
  'Not_Same_Product': '非同款產品',
  'Empty_Code': '驗證碼為空',
  'Product_Not_Exist': '產品不存在',
  'Product_Unlocked': '產品已解鎖',
  'Product_Not_Activated': '產品未啟用',
  'Inconsistent_Product_Code': '產品碼不一致',
  'No_Empty_Type': '類型不能為空',
  'No_Empty_Reason': '原因不能為空',
  'Invalid_Product_Code_Or_Invalid_Active_Code': '無效產品碼或啟用碼',
  '请选择要导入的文件': '請選擇要導入的檔案',
  '请使用正确的导入模板': '請使用正確的匯入範本',
  '文件名不能为空': '檔名不能為空',
  '文件格式错误': '檔案格式錯誤',
  '请上传Excel文件': '請上傳Excel檔案',
  'Excel格式错误': 'Excel格式錯誤',
  'Excel内容为空': 'Excel內容為空',
  'Row{}：Enter_Agent_Account': '第{}行：請輸入代理賬號',
  'Row{}：UserName_Only_Contain_Number_And_English': '第{}行：賬號只包含數字和英文',
  'Row{}：UserName_Exist': '第{}行：賬號已存在',
  'Row{}：Enter_Agent_Name': '第{}行：請輸入代理名稱',
  'Row{}：Enter_Phone_Number': '第{}行：請輸入手機號碼',
  'Row{}：Invalid_Phone_Number': '第{}行：無效手機號碼',
  'Row{}：Select_Region': '第{}行：請選擇地區',
  'Row{}：Invalid_Region': '第{}行：無效地區',
  'Row{}：Enter_Address': '第{}行：請輸入地址',
  '生成Excel失败': '生成Excel失敗',
  '请输入国家名称': '請輸入國家名稱',
  '订单不存在': '訂單不存在',
  '箱规必须大于0': '箱規必須大於0',
  '箱子已绑定产品，不能删除': '箱子已綁定產品，不能刪除',
  '箱子不存在': '箱子不存在',
  '该箱已绑定产品': '該箱已綁定產品',
  '订单ID不能为空': '訂單ID不能為空',
  'Enter_Agent_Account': '請輸入代理賬號',
  'Enter_Staff_Account': '請輸入員工賬號',
  'UserName_Only_Contain_Number_And_English': '賬號只包含數字和英文',
  'UserName_Exist': '賬號已存在',
  'Enter_Staff_Name': '請輸入員工名稱',
  'Enter_Remark': '請輸入備註',
}

export default {
  ...Common,
  ...Layout,
  ...Menu,
  ...Region,
  ...ModifyPasswordPage,
  ...LoginPage,
  ...TenantPage,
  ...RolePage,
  ...StaffPage,
  ...PrintRecordPage,
  ...ThirdPartyActivationCodeOrderPage,
  ...ThirdPartyActivationCodeRecordPage,
  ...TraceCodePage,
  ...ReturnPage,
  ...StockChangePage,
  ...StockPage,
  ...SaleOutWarehousePage,
  ...SaleOrderPage,
  ...PurchaseInWarehousePage,
  ...PurchaseOrderPage,
  ...AppUserPage,
  ...ProduceInWarehousePage,
  ...ProduceOrderPage,
  ...OnSaleProductPage,
  ...ProductPage,
  ...AgentPage,
  ...SupplierPage,
  ...StatisticsPage,
  ...InsiteMessagePage,
  ...AgentPurchasePage,
  ...CampaignPage,
  ...BackEnd,
}